import { render } from "./settings-sidebar.vue?vue&type=template&id=22134d54"
import script from "./settings-sidebar.vue?vue&type=script&lang=js"
export * from "./settings-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__